import { isTelegramMiniApp } from "./telegram";
import { isMaxMiniApp, getMaxWebApp } from "./max";
/**
 * Открыть внешний URL из мини-аппа через мост платформы.
 *
 * В вебвью Telegram/MAX клик по `<a download>` не скачивает файл, а НАВИГИРУЕТ
 * webview (атрибут `download` игнорируется) — пользователь видит редирект/
 * проигрывание вместо сохранения. Правильный путь — отдать ссылку мосту
 * (`openLink`), который открывает её во внешнем системном браузере, где и
 * происходит скачивание (по `Content-Disposition: attachment`) или открытие
 * страницы. То же ограничение у `navigator.share`/`navigator.clipboard` —
 * в MAX они недоступны, поэтому шаринг ссылок тоже идёт через этот хелпер.
 *
 * Возвращает `true`, если ссылку удалось открыть через мост мини-аппа, и
 * `false` в обычном вебе (или если мост недоступен) — тогда вызывающий код
 * применяет свой веб-фолбэк (скачивание якорем, navigator.share и т.п.).
 *
 * Образец логики веток — paymentNavigation.ts (navigateToPaymentPage).
 */
export function openExternalUrl(rawUrl) {
    const trimmed = rawUrl?.trim();
    if (!trimmed)
        return false;
    let url;
    try {
        url = new URL(trimmed, window.location.href).href;
    }
    catch {
        return false;
    }
    // Telegram Mini App — открываем во внешнем браузере через мост.
    if (isTelegramMiniApp() && window.Telegram?.WebApp?.openLink) {
        window.Telegram.WebApp.openLink(url);
        return true;
    }
    // MAX Mini App — то же самое через свой мост.
    if (isMaxMiniApp()) {
        const maxApp = getMaxWebApp();
        if (maxApp?.openLink) {
            maxApp.openLink(url);
            return true;
        }
    }
    return false;
}
